export default "__VITE_ASSET__8fvZ5zpu__"